import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { SelectPaymentMethodActionBaseComponent } from '@luggagehero/features/bookings';
import { SharedBookingService } from '@luggagehero/shared/services/bookings';
import { SharedLoggingService } from '@luggagehero/shared/services/logging';
import { SharedPaymentService } from '@luggagehero/shared/services/payments';
import { SharedShopsService } from '@luggagehero/shared/services/shops';
import { SharedStorageService } from '@luggagehero/shared/services/storage';

@Component({
  selector: 'lh-select-payment-method-action',
  templateUrl: './select-payment-method-action.component.html',
  styleUrls: ['./select-payment-method-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectPaymentMethodActionComponent extends SelectPaymentMethodActionBaseComponent {
  constructor(
    paymentService: SharedPaymentService,
    log: SharedLoggingService,
    bookingService: SharedBookingService,
    shopsService: SharedShopsService,
    storageService: SharedStorageService,
    cd: ChangeDetectorRef,
  ) {
    super(paymentService, log, bookingService, shopsService, storageService, cd);
  }
}
